import { InjectionToken } from '@angular/core';

export const SERVICE_WORKER_API_AVAILABLE = new InjectionToken<boolean>('SERVICE_WORKER_API_AVAILABLE');
